import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope'];

class DwmFaqController {

    constructor($scope) {

        $scope.activeQuestion = 'q1';

        const sendQuestionClickEvent = (q) => {

            if (q === 'q1') {

                Mixpanel.send('ConnectWeb AIA FAQ Click', {
                    Title: 'What is AIA?',
                });

            } else if (q === 'q2') {

                Mixpanel.send('ConnectWeb AIA FAQ Click', {
                    Title: 'DWM Notification',
                });

            } else {

                Mixpanel.send('ConnectWeb AIA FAQ Click', {
                    Title: 'What is DWM?',
                });

            }

        };

        $scope.changeQuestion = (question) => {

            $scope.activeQuestion = question;
            sendQuestionClickEvent(question);

        };

        $scope.currentLanguage = CWCONFIG.language;

    }

}


class DwmFaqDirective {

    constructor() {

        this.template = require('./dwm-faq.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push($scope =>
            new DwmFaqController($scope));
        this.controller = _controllerDependencies;
        this.controllerAs = 'DwmFaqCtrl';

    }

}

_directiveDependencies.push(() => new DwmFaqDirective());


angular.module('directives')
    .directive('dwmFaq', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/dwm-faq/dwm-faq.js